import {
  Badge,
  Button,
  CircularProgress,
  IconButton,
  Stack,
  Switch,
  Tooltip,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { Box } from "@mui/system";
import NotificationModal from "components/notification/NotificationModal";
import { pageTransition, pageVariants } from "config/helpers/animation_helper";
import { getPathNames } from "config/helpers/router_helper";
import { motion } from "framer-motion";
import $ from "jquery";
import { isBoolean, isEqual } from "lodash";
import { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";

import {
  GET_VISITS_BY_KEYWORD,
  SAVE_USER_SETTINGS,
} from "adapters/ehr.service";
import { notification_icon } from "assets/icons/notificationIcon";
import TextAvatar from "components/avatar/TextAvatar";
// import TypeformEmbed from "components/feedback/TypeformEmbed";
import Available247 from "components/feedback/Available247";
import ProfileModal from "components/profile/Profile_v2";
import EllipsisWithTooltip from "components/ui/EllipsisWithOverflow";
import UITooltip from "components/ui/Tooltip/UITooltip";
import { getDeviceDetails, cleanName } from "config/helpers/common_helper";
import { formatDate } from "config/helpers/date_helper";
import { SvgToMuiIcon } from "config/helpers/Icon_helper";
import { debounce } from "lodash";
import { useLocation, useNavigate } from "react-router-dom";
import { read_notifications, set_edit_widget } from "redux/actions/AppActions";
import { set_current_user_setting } from "redux/actions/AuthActions";
import { encounterObject, quickActionToggle } from "redux/actions/EncounterActions";
import { setSearchKeyword } from "redux/actions/SearchActions";
import scribsIcon from "../../assets/icons/scribs-icon.svg";
import JoyrideMobileComponent from "components/wrapper_v2/JoyrideMobileComponent";
import { show_redirect_popup } from "redux/actions/MobileTabActions";
import useDeviceName from "components/Devices/detectDevices";
import PatientUpdateMobileComponent from "mobile/screens/patient/PatientUpdateMobileComponent";
import { getCurrentRecordingState } from "config/helpers/recordingStateSelector";

const NotificationIcon = SvgToMuiIcon(notification_icon);

const MobileTopbar = (props) => {
  const showPopup = useSelector((state) => state?.scribe?.showPopup);

  const reduxDispatch = useDispatch();
  const practitionerData = useSelector(
    (state) => state?.auth?.practitionerData
  );
  const personData = useSelector(
    (state) => state?.auth?.personData
  );
  const { i18n } = useTranslation();
  const isMobile = useMediaQuery("(max-width:767px)");
  const navigate = useNavigate();
  const app = useSelector((state) => state.app, isEqual);
  const { relatedPersons } = useSelector((state) => state?.auth);
  const loggedInUserData = useSelector((state) => state?.auth?.userData);
  const auth = useSelector((state) => state?.auth);
  const deviceDetails = getDeviceDetails(useDeviceName());
  const userFirstname = practitionerData?.name?.[0]?.text
    ?.split(" ")
    ?.slice(0, 2)
    ?.join(" ");
  const [modalOpen, setModalOpen] = useState(false);
  const [profileModalOpen, setProfileModalOpen] = useState(false);
  const [joyrideSteps, setJoyrideSteps] = useState([]);
  const [isJoyrideActive, setIsJoyrideActive] = useState(false);
  const [currentStep, setCurrentStep] = useState(0);
  const [loadingPersonChange, setLoadingPersonChange] = useState(false);
  const [isFirstVisit, setIsFirstVist] = useState(true);
  const [countOfNotifications, setCountOfNotifications] = useState(0);
  const [showGenerationInProgress, setShowGenerationInProgress] = useState(false);
  const totalSteps = joyrideSteps.length;

  const [searchedData, setSearchedData] = useState([]);
  const [inputData, setInputData] = useState("");
  const currentUserSettingsData = useSelector(
    (state) => state?.auth?.currentUserSettings
  );
  const location = useLocation();

  const currentUserPracticeData = useSelector(
    (state) => state?.auth?.currentUserPracticeData
  );

  const patientId = useSelector((state) => state.patientObj?.patientObj?.id);
  const encounterId = useSelector((state) => state.encounterObj?.encounter?.id);

  const { recording: isRecording, paused: isPaused } = useSelector((state) =>
    getCurrentRecordingState(state, patientId, encounterId)
  );

  const patientName = useSelector(
    (state) => state?.patientObj?.patientObj?.name?.[0]?.text
  );

  const currentVisitList = useSelector(
    (state) => state?.encounterObj?.visitList
  );

  const editWidgetChecked = useSelector((state) => {
    return state?.app?.editWidget;
  });

  const [loading, setLoading] = useState(false);

  const [isSuggShow, setSuggShow] = useState(false);

  const path = window.location.pathname;
  const context = path.includes("/patients/list")
    ? "patients"
    : path.includes("/patients/visits")
      ? "encounters"
      : path.includes("/home/dashboard")
        ? "dashboard"
        : null;

  const openModal = () => {
    setModalOpen(true);
  };
  const handleProfileModalOpen = () => {
    setProfileModalOpen(true);
  };
  const closeModal = () => {
    reduxDispatch(read_notifications());
    setModalOpen(false);
  };
  const handleProfileModalClose = () => {
    setProfileModalOpen(false);
  };
  const sidebarMobileToggle = (e) => {
    e.preventDefault();
    $("#aside").toggleClass("sidebar-expand");
    $(".sidebar-overlay").toggleClass("active");
  };

  const [selectedItem, setSelectedItem] = useState(
    auth.relatedPersons.find(
      (f) => f.disabled === false && f.patientId === auth.activePersonId
    )
  );

  const queryParams = new URLSearchParams(window.location.search);
  const visitId = queryParams.get("visitId");

  useEffect(() => {
    initializeJoyride();
  }, []);

  useEffect(() => {
    if (
      isBoolean(!currentUserSettingsData?.display?.isIntroDone) &&
      location?.pathname?.includes("/home/dashboard")
    ) {
      if (currentUserSettingsData?.display?.isIntroDone) {
        setIsJoyrideActive(false);
      } else if (
        currentUserPracticeData?.practiceData?.practice_speciality ||
        currentUserPracticeData?.practiceData?.isFirstVisitSkipped
      ) {
        initializeJoyride();
        setIsJoyrideActive(true);
      }
    }
  }, [
    currentUserSettingsData?.display?.isIntroDone,
    app?.isDashboardLoaded,
    currentUserPracticeData?.practiceData,
  ]);

  const updateUserSetting = async (updateValue) => {
    let setting = {
      ...currentUserSettingsData?.display,
      ...updateValue,
    };

    let payload = structuredClone(currentUserSettingsData?.resource);
    payload.extension = [
      {
        url: "http://enliv.com/settings/data",
        valueString: JSON.stringify(setting),
      },
    ];
    try {
      const response = await SAVE_USER_SETTINGS(`PUT`, payload);
      const rawData = { ...response?.data };
      const displaySetting = rawData?.extension?.find(
        (item) => item?.url === "http://enliv.com/settings/data"
      )?.valueString;
      reduxDispatch(
        set_current_user_setting({
          resource: { ...rawData },
          display: JSON?.parse(displaySetting),
        })
      );
    } catch (e) {
      console.error(e);
    } finally {
      console.log("updated user settings");
    }
  };

  useEffect(() => {
    const hasCompletedTour = localStorage.getItem("hasCompletedTour");

    if (hasCompletedTour !== "true") {
      initializeJoyride();
    } else {
      setIsJoyrideActive(false);
    }
  }, []);

  const scrollToElement = (selector) => {
    const element = document.querySelector(selector);
    if (element) {
      const elementRect = element.getBoundingClientRect();
      const absoluteElementTop = elementRect.top + window.pageYOffset;
      const middle = absoluteElementTop - window.innerHeight / 2;
      window.scrollTo(0, middle);
    }
  };

  const findScrollableParent = (element) => {
    if (!element) return document.documentElement;
    if (element.scrollHeight > element.clientHeight) {
      return element;
    } else {
      return findScrollableParent(element.parentElement);
    }
  };

  const handleJoyrideCallback = (data) => {
    const { index, type, status, step } = data;
    if (type === "step:before") {
      setCurrentStep(index);
    }

    // if (type === 'step:before' && step.scrollTo && index === 5) {
    //   scrollToElement(step.target);
    // }

    if (type === "step:before" && step.scrollTo) {
      const element = document.querySelector(step.target);
      if (element) {
        setTimeout(() => {
          element.scrollIntoView({ behavior: "smooth", block: "end" });
        }, 100);
      }
    }

    if (type === "step:before" && index === joyrideSteps.length - 1) {
      setTimeout(() => {
        const lastButton = document.querySelector(
          'button[data-action="primary"]'
        );
        if (lastButton) {
          lastButton.innerHTML = `${i18n.t("common.FINISH")}`;
        }
      }, 0);
    }

    if (status === "finished" || status === "paused" || status === "skipped") {
      setTimeout(() => {
        const scrollDashElement = document.querySelector(".scrollDash");
        if (scrollDashElement) {
          scrollDashElement.scrollIntoView({
            behavior: "smooth",
            block: "start",
          });
          setTimeout(() => {
            scrollDashElement.scrollTop = 0;
          }, 100);
        }
      }, 100);
      setIsJoyrideActive(false);
      localStorage.setItem("hasCompletedTour", "true");
      updateUserSetting({ isIntroDone: true });
      if (deviceDetails?.redirectLink) {
        reduxDispatch(show_redirect_popup(true));
      }
    }
  };

  const initializeJoyride = () => {
    const baseSteps = [
      {
        target: ".step-mobile-1",
        content: `${i18n.t("joyride.STEP_1")}`,
        title: `${i18n?.t("common.WELCOME_USER")}!!`,
        placement: "center",
        scrollToAlignment: "center",
      },
      {
        target: ".step-mobile-2",
        // title:"Menu",
        content: `${i18n.t("joyride.STEP_2_MOBILE")}`,
        placement: "right",
        scrollTo: true,
        scrollToAlignment: "start",
      },
      {
        target: ".step-mobile-3",
        // title:"Create Patient",
        content: `${i18n.t("joyride.STEP_3_MOBILE")}`,
        // placement: "right",
        placement: "right",
        offset: 2,
        scrollTo: true,
        scrollToAlignment: "start",
      },
      {
        target: ".step-mobile-4",
        // title:"Patients",
        content: `${i18n.t("joyride.STEP_4_MOBILE")}`,
        placement: "right",
        // offset: 30,
        offset: 5,
        scrollTo: true,
        // spotlightPadding: 0,
        scrollToAlignment: "start",
      },
      {
        target: ".step-mobile-5",
        // title:"Start New Encounter",
        content: `${i18n.t("joyride.STEP_5_MOBILE")}`,
        placement: "right",
        // offset: 30,
        offset: 5,
        scrollTo: true,
        // spotlightPadding: 0,
        scrollToAlignment: "start",
      },
      {
        target: ".step-mobile-6",
        content: `${i18n.t("joyride.STEP_6_MOBILE")}`,
        placement: "top",
        offset: 30,
        scrollTo: true,
        // spotlightPadding: 0,
        scrollToAlignment: "end",
      },
      {
        target: ".step-mobile-7",
        content: `${i18n.t("joyride.STEP_7_MOBILE")}`,
        placement: "right",
        // offset: 30,
        offset: 5,
        scrollTo: true,
        // spotlightPadding: 0,
        scrollToAlignment: "start",
      },
    ];
    setJoyrideSteps(baseSteps);
  };

  const handleSelect = (value) => {
    setSelectedItem(value);
  };
  const handleClose = () => {
    setIsFirstVist(false);
    updateUserSetting({ isNewUser: false });
  };
  useEffect(() => {
    return () => {
      reduxDispatch(setSearchKeyword("", null));
      setInputData("");
      setSuggShow(false);
    };
  }, [path]);

  const searchFn = async (keyword, { patientId = "" } = {}) => {
    try {
      setLoading(true);
      const compositionResponse = await GET_VISITS_BY_KEYWORD({
        patientId,
        searchKeyword: keyword,
      });
      setSearchedData(compositionResponse?.data?.entry);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const handleSearch = (event) => {
    const keyword = event.target.value;
    const regex = /^[a-zA-Z ]*$/;
    setInputData(keyword);
    if (regex.test(keyword)) {
      if (context === "encounters" && keyword?.trim()?.length > 0) {
        !isSuggShow && setSuggShow(true);
        setSearchedData([]);
        debouncedSearch(keyword);
      } else {
        setSuggShow(false);
      }
      if (keyword == "") {
        reduxDispatch(setSearchKeyword(keyword, context));
      } else if (keyword?.trim()?.length > 0) {
        reduxDispatch(setSearchKeyword(keyword, context));
      }
    }
  };

  const debouncedSearch = useCallback(
    debounce((keyword) => {
      searchFn(keyword, { patientId: patientId?.id });
    }, 800),
    [patientId]
  );

  const onSuggestedItemClick = (visit) => {
    let selectedEncounterComponsition = [];
    for (const list of currentVisitList) {
      if (selectedEncounterComponsition.length) {
        break;
      }
      selectedEncounterComponsition = list.filter(
        (f) =>
          f?.resource?.encounter?.reference ===
          visit?.resource?.encounter?.reference
      );
    }

    reduxDispatch(
      encounterObject({
        id: visit?.resource?.encounter?.reference?.split("/")?.[1],
        compositionList: [...selectedEncounterComponsition],
        compositionListStatic: [...selectedEncounterComponsition],
        composition: selectedEncounterComponsition?.[0]?.resource,
      })
    );
    setSuggShow(false);
    reduxDispatch(setSearchKeyword("", null));
    setInputData("");
  };

  const handleEditWidget = (event) => {
    const { name, value, checked } = event?.target;
    if (name === "editToggle") {
      reduxDispatch(set_edit_widget(checked));
    }
  };

  return (
    <>
      {/* <JoyrideMobileComponent
        joyrideSteps={joyrideSteps}
        handleJoyrideCallback={handleJoyrideCallback}
        isJoyrideActive={isJoyrideActive}
        currentStep={currentStep}
        totalSteps={totalSteps}
      /> */}
      <header className="step-mobile-1 w-100" id="header">
        <nav className={`navbar-expand main-nav navbar-${app.theme}`}>
          <div className="container-fluid">
            <button
              type="button"
              className="sidebar-toggle-btn-mobile"
              onClick={sidebarMobileToggle}
            >
              <span className="navbar-toggler-icon"></span>
            </button>
            <div
              className="collapse navbar-collapse align-items-center justify-content-between w-100"
              style={{
                height: "5vh",
                width: "70vw",
                justifyContent: "space-between",
              }}
            >
              <div
                id="header-breadcrumb"
                className="d-flex header-breadcrumb align-items-center"
                style={{ paddingLeft: "15px" }}
              >
                <motion.div
                  key={getPathNames()}
                  initial="initial"
                  animate="in"
                  variants={pageVariants}
                  transition={pageTransition}
                >
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <div
                      className="d-flex align-items-center"
                      style={{
                        fontWeight: "500",
                        fontSize: "clamp(1.5vh, 1.5vw, 1.5vw)",
                      }}
                    >
                      {path.includes("/home/dashboard") && (
                        <>{`${i18n.t("common.HELLO")}, ${cleanName(
                          personData?.name?.[0]?.text
                        )}`}</>
                      )}
                      {path.includes("/patients/visits") && <>{patientName}</>}
                      {path.includes("/patients/list") && (
                        <>{i18n.t("Side_Menu.Patients")}</>
                      )}
                      {path.includes("/home/support") && (
                        <>{i18n.t("SUPPORT.CONTACT_SUPPORT")}</>
                      )}
                      {path.includes("/home/planparticulars") && (
                        <>{i18n.t("dashboard2.PLAN_PARTICULARS")}</>
                      )}
                    </div>
                  </div>
                </motion.div>
              </div>
              <ul className="navbar-nav ms-auto p-0 m-0 d-flex align-items-center">
                {(path.includes("/patients/list") ||
                  path.includes("/patients/visits")) && (
                    <>
                      {isSuggShow && (
                        <div
                          style={{
                            height: "100dvh",
                            width: "100dvw",
                            position: "fixed",
                            top: 0,
                            left: 0,
                            zIndex: 700,
                            // backgroundColor: "",
                          }}
                          onClick={(e) => {
                            setSuggShow(false);
                          }}
                        />
                      )}
                    </>
                  )}

                {location?.pathname === "/home/dashboard" && (
                  <li className="me-2">
                    <Stack direction={"row"} spacing={0} alignItems={"center"}>
                      <Typography
                        fontSize="small"
                        sx={{
                          color: "toolBarIcon",
                          fontSize: "10px",
                        }}
                      >
                        {i18n.t("dashboard.VIEW")}
                      </Typography>
                      <Switch
                        size="small"
                        name={"editToggle"}
                        checked={editWidgetChecked}
                        onChange={handleEditWidget}
                      />
                      <Typography
                        fontSize="small"
                        sx={{
                          color: "toolBarIcon",
                          fontSize: "10px",
                        }}
                      >
                        {i18n.t("dashboard.EDIT")}
                      </Typography>
                    </Stack>
                  </li>
                )}
                {/* <li>
                  <Available247 />
                </li> */}
                <li
                  className="d-flex justify-content-between align-items-center page-bg"
                  style={{
                    borderRadius: "20px",
                    height: "25px",
                    marginLeft: "6px",
                    gap: "10px",
                  }}
                >
                  <Tooltip
                    enterTouchDelay={0}
                    title={i18n.t("notifications.NOTIFICATION")}
                    className={isMobile ? "step-mobile-7" : ""}
                  >
                    <IconButton
                      className="rounded"
                      disableRipple
                      onClick={() => {
                        openModal();
                      }}
                      sx={{ padding: "0.5vw 0.5vw" }}
                    >
                      <Badge
                          badgeContent={countOfNotifications}
                          
                        color={"error"}
                        sx={{
                          "& .MuiBadge-badge": {
                            top: 3,
                            padding: isMobile ? "0.5vh" : "0.1vw",
                            minWidth: "0",
                            height: "0.6vw",
                            width: "0.6vw",
                            borderRadius: "50%",
                            fontSize: "2vw",
                            top: isMobile ? "0.5vh" : "0.9vh",
                            right: isMobile ? "1.3vh" : "0.8vw",
                          },
                        }}
                      >
                        <div className="text-primary">
                          <NotificationIcon
                            color={
                              currentUserSettingsData?.display?.theme === "dark"
                                ? "#ffffff"
                                : "#4A5568"
                            }
                            sx={{ fontSize: "1.45rem" }}
                          />
                        </div>
                      </Badge>
                    </IconButton>
                  </Tooltip>
                  
                </li>
                
              </ul>

              {path.includes("/patients/visits") &&
                !encounterId &&
                !visitId && <PatientUpdateMobileComponent />}
              {path.includes("/patients/visits") && encounterId && visitId && (
                <Button
                  sx={style.buttonStyle}
                  variant="outlined"
                  onClick={() => {
                    reduxDispatch(quickActionToggle(true));
                  }}
                  disabled={isRecording || isPaused}
                >
                  <Typography
                    sx={{
                      fontSize: "clamp(1.5vh, 1.5vw, 1.5vw)",
                    }}
                  >
                    {i18n.t("common.QUICK_ACTIONS")}
                  </Typography>
                </Button>
              )}
            </div>
          </div>
        </nav>
      </header>
      <NotificationModal 
        open={modalOpen} 
        onClose={closeModal} 
        setCountOfNotifications={setCountOfNotifications} 
        setShowGenerationInProgress={setShowGenerationInProgress} 
      />
      <ProfileModal
        open={profileModalOpen}
        onClose={handleProfileModalClose}
      />
      {/* {isMobile && <BreadcrumbsMobile />} */}
    </>
  );
};

const SearchSuggestionCard = ({ suggestions, onClick = () => { }, loading }) => {
  // const loading = useSelector((state) => state?.isLoading?.loading);
  const { keyword } = useSelector((state) => state?.search);

  const highlightAndTruncateText = (text) => {
    if (!keyword.trim()) return text;

    const keywordRegex = new RegExp(`(${keyword})`, "gi");
    const matchIndex = text.search(keywordRegex);

    const charsBefore = 5;
    const charsAfter = 250;

    let startIndex = Math.max(matchIndex - charsBefore, 0);
    let endIndex = Math.min(
      matchIndex + keyword.length + charsAfter,
      text.length
    );

    while (startIndex > 0 && text[startIndex - 1] !== " ") {
      startIndex--;
    }

    let resultText = text.substring(startIndex, endIndex);
    resultText = resultText.replace(
      keywordRegex,
      `<span style="background-color: yellow;">$1</span>`
    );

    return resultText;
  };

  return (
    <div
      className="border rounded-4 search-suggestion-card"
      style={{ zIndex: 1100 }}
    >
      {loading ? (
        <div
          className="page-bg rounded-4"
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            // backgroundColor: "rgba(255, 255, 255, 0.8)",
            backdropFilter: "blur(5px)",
          }}
        >
          <CircularProgress color="inherit" />
        </div>
      ) : suggestions?.length > 0 ? (
        suggestions.map((item, index) => {
          const data = {
            // title: highlightAndTruncateText(item?.resource?.valueString || "-"),
            title: item?.resource?.title,
            // date: formatDate(item?.resource?.effectiveDateTime) || "-",
            date: formatDate(item?.resource?.date) || "-",
            from: "Composition",
            type: "Composition",
          };

          return (
            <Box
              key={index}
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                p: 2,
                // flexDirection: { xs: "column", md: "row" },
                // flexDirection: "row",
                borderTop: data?.type === "clinicalNote" ? "1px solid" : "none",
              }}
              className={`${data?.type === "clinicalNote" ? "border-top" : ""
                } search-suggestion-item`}
              onClick={() => onClick(item)}
            >
              <div style={{ width: "80%" }}>
                <EllipsisWithTooltip>
                  {/* <div
                        className="fxs b-600 text-truncate"
                        style={{ maxWidth: "200px" }}
                        dangerouslySetInnerHTML={{
                          __html: data.title,
                        }}
                      ></div> */}
                  {data?.title}
                </EllipsisWithTooltip>
                <div
                  className="fxxs b-400 text-muted text-truncate"
                  style={{ maxWidth: "150px" }}
                >
                  {/* {data?.type === "clinicalNote" ? data?.date : data?.desc} */}
                  {data?.date}
                </div>
              </div>
              <div
                className="fxs text-muted text-truncate"
                style={{ maxWidth: "150px" }}
              >
                {data?.type !== "clinicalNote" ? (
                  <img src={scribsIcon} alt="icon" />
                ) : (
                  "From " + data?.from
                )}
                {/* <img src={scribsIcon} alt="icon" /> */}
              </div>
            </Box>
          );
        })
      ) : (
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            // backgroundColor: "rgba(255, 255, 255, 0.8)",
            backdropFilter: "blur(5px)",
          }}
          className="page-bg rounded-4"
        >
          No Result Found
        </div>
      )}
    </div>
  );
};

const style = {
  buttonStyle: {
    padding: "0.3vw 0.5vw",
    color: "#fff",
    background:
      "linear-gradient(90deg, rgba(43, 44, 119, 0.5) 47.31%, rgba(188, 184, 184, 0.5) 129.24%)",
    textTransform: "none",
    borderRadius: "2vw",
  },
};

export default MobileTopbar;
